import './app';

window.addEventListener('DOMContentLoaded', async () => {
    try {
        await screen.orientation.lock("landscape")
    } catch (error) {
        console.error("Error locking screen orientation:", error);
    }
})